import { configureStore as createStore } from "@reduxjs/toolkit"
import { createReducerManager } from "../reducers"

import { directAxiosInstance, ppmcAxiosInstance } from "@lib/api"

const configureStore = (initialState, cookies, requestObj, customHeaders) => {
    // The variable defined below acts as a flag when the store is initialized on the client side
    // Reason being that for the first time we need to actually need to forcefully set the reducer for which we have the initial data
    let initializeClient = true
    const api = directAxiosInstance(cookies, requestObj, customHeaders)
    const ppmcApi = ppmcAxiosInstance(cookies, requestObj)
    const reducerManager = createReducerManager()
    const addReducer = (reducer) => {
        // Only executed once when for the first run in client - side
        if (initializeClient) {
            initializeClient = false
            return store.replaceReducer(reducerManager.add(reducer))
        }

        // This blocks check if the reducer is already added or not in store
        // If not then it only add the missing reducers
        // And if the required reducers are already present then we simply return without performing any change

        const reducerToAdd = {}
        const currentState = store.getState()
        for (const key in reducer) {
            if (!currentState[key]) {
                reducerToAdd[key] = reducer[key]
            }
        }
        if (Object.keys(reducerToAdd).length > 0) {
            return store.replaceReducer(reducerManager.add(reducerToAdd))
        }
        return
    }
    const store = createStore({
        reducer: Object.keys(initialState).length === 0 ? reducerManager.getReducerMap() : () => initialState,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                thunk: {
                    extraArgument: { api, ppmcApi, addReducer },
                },
            }),
        preloadedState: initialState,
        devTools: false,
    })
    return store
}

export default configureStore
